export default __webpack_public_path__ + "static/media/avatar_tommy5.6a3d397a.mp3";